import { styled } from '@linaria/react';
import {
  colors,
  fonts,
  layout,
  primitives,
  semantic,
  shadow,
  size,
  space,
} from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TriggerButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  width: 100%;
  background: ${semantic.bg.canvas};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xs']};
  padding: ${space['space-200']} ${space['space-300']};
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: ${colors.primary};
  }
`;

export const TriggerLabel = styled.span`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.secondary};
  text-transform: uppercase;
  letter-spacing: ${primitives.typography.tracking.wide};
`;

export const TriggerValue = styled.span`
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;

export const Dropdown = styled.div<{ $asInline?: boolean; $withShadow?: boolean }>`
  position: ${({ $asInline }) => ($asInline ? 'relative' : 'absolute')};
  top: ${({ $asInline }) => ($asInline ? '0' : 'calc(100% + 4px)')};
  left: 0;
  z-index: ${layout.zIndexDropdown};
  background: ${semantic.bg.canvas};
  border-radius: ${size.radius['radius-md']};
  box-shadow: ${({ $asInline, $withShadow }) => (!$asInline || $withShadow ? shadow.lg : 'none')};
  padding: ${space['space-600']};
  min-width: 280px;
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-600']};
  padding: ${space['space-400']} 0;

  & + & {
    border-top: 1px solid ${semantic.border.subtle};
  }
`;

export const CounterLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
`;
